module.exports = __webpack_public_path__ + "static/media/bulb.cb8deaca.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/bulb.png
// module id = 761
// module chunks = 0